module.exports = __webpack_public_path__ + "static/media/burn.60c3eb55.svg";